<template>
    <div class = "print" v-if="getPermission.settings.view">

        <md-tabs md-sync-route class="version-tabs">
          <md-tab id="tab-version_web" md-label="Web" to="/version/web"></md-tab>
          <md-tab id="tab-version_app" md-label="App" to="/version/app"></md-tab>
        </md-tabs>
        <router-view/>

    </div>

</template>

<style lang="scss">

  .Version-tabs {
    .md-tabs-navigation {
      .md-theme-default {
        height: 30px;
      }
    }
  }

  


</style>


<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({}),
    computed: {
      ...mapGetters([
        'getPermission',
        // 'getMasterDataName',
      ]),
    },
  };

</script>



